import {useSelector} from 'react-redux';
import {useParams} from 'react-router-dom';
import {getSubMenu} from '../../functions/navigationFunctions';
import {hasEventRoleAccess, isMaster} from '../../functions/permission';
import {menuEvent} from '../menu';
import {menuAccount} from '../menuAccount';
import useTablet from '../../hooks/useTablet';

export default function useNavigationList(idParams,pageId) {

    const isTablet = useTablet();
    const event = useSelector(state => state.event);
    const menuJson = event ? menuEvent : menuAccount;
    const {page} = useParams();
    const pageUrl = pageId||page;

    let subMenu =  getSubMenu(pageUrl,event);

    subMenu = subMenu.filter(([key, item]) => {
        // Standard checks: event type compatibility + role access
        const standardCheck = ((!item.events || item.events && item.events?.indexOf(event?.type) != -1) &&
                              (!item.condition || item.condition(event)) &&
                              hasEventRoleAccess(item.access));

        // Additional check for WhatsApp tabs: must have hasWhatsappAccess === true
        // Exception: Master users can access WhatsApp for all events
        if(key === 'publish/whatsapp' || key === 'publishGivechak/whatsapp') {
            return standardCheck && (event?.hasWhatsappAccess === true || isMaster());
        }

        return standardCheck;
    });
    if(subMenu.length || (isTablet && idParams && !pageId)) {
        let firstItem = Object.entries(menuJson).filter(([, item]) => item.path == `/${event.type === 'givechak' && pageUrl === 'publish' ? 'publishGivechak' : pageUrl}`)[0];
        if(firstItem) {
            firstItem[1] = {...firstItem[1], title: `${pageUrl}Main`};
            subMenu = [firstItem, ...subMenu];
        }
    }
    return subMenu;
}
